var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress progress-bar-vertical"},[_c('div',{class:['progress-bar', _vm.variant ? `bg-${_vm.variant}` : ''],style:({ height: `${ _vm.value }%` }),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":_vm.min,"aria-valuemax":_vm.max}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.value)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }